import template from './trip-add-to-calendar.html';

const DIRECTIVE_NAME = TripAddToCalendar.DIRECTIVE_NAME = 'ktTripAddToCalendar';
export default function TripAddToCalendar() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripAddToCalendarController,
        controllerAs: 'tripAddToCalendarCtrl',
        scope: {
            tripDetails: `=${DIRECTIVE_NAME}`,
            onCancel: `&${DIRECTIVE_NAME}OnCancel`,
        },
        link: function($scope, $elem, $attrs, tripAddToCalendarCtrl) {
            tripAddToCalendarCtrl.$onInit();
        },
    };
}

export function TripAddToCalendarController(tripAddToCalendarService) {
    'ngInject';
    const vm = this;

    const DEFAULT_CHECK_STATE = false;
    let isFormInProgress = false;

    Object.assign(vm, {
        $onInit,
        send,
        isSomeTravellerSelected,
        getErrors,
        closeConfirmationAlert,
        isConfirmationAlertVisible: false,
        isFormVisible: true,
    });

    function $onInit() {
        initTravellers();
    }
    function closeConfirmationAlert() {
        vm.isConfirmationAlertVisible = false;
    }

    function initTravellers() {
        if (!(vm.tripDetails && vm.tripDetails.Travelers && vm.tripDetails.Travelers.Adult)) {
            return;
        }
        const adults = vm.tripDetails.Travelers.Adult;
        vm.travellers = adults.map(({Id, EmailAddress, FirstName, LastName}) => ({
            id: Id,
            email: EmailAddress,
            name: `${FirstName} ${LastName}`,
            selected: DEFAULT_CHECK_STATE,
        }));
    }

    function send() {
        if (isFormInProgress) {
            return;
        }
        isFormInProgress = true;

        const travellersToSend = vm.travellers.filter(({selected}) => selected);
        if (!travellersToSend.length) {
            vm.isFormVisible = false;
            vm.isConfirmationAlertVisible = true;
            return;
        }

        tripAddToCalendarService.send(travellersToSend, vm.tripDetails.Id)
            .then(() => {
                vm.isConfirmationAlertVisible = true;
                vm.isFormVisible = false;
            })
            .finally(() => isFormInProgress = false);
    }

    function isSomeTravellerSelected() {
        return !!vm.travellers.filter(({selected}) => selected).length;
    }

    function getErrors(form, index) {
        const fieldName = `email_${index}`;
        return form[fieldName] && form[fieldName].$error || {};
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-add-to-calendar/trip-add-to-calendar-component.js